import { Directive, Output, EventEmitter, HostListener, Input } from '@angular/core';
import { SvgDraggable, SvgDragService } from './svg-drag.service';

export class SvgDragEndedEvent {
  index: number;
  targetIndex: number;
}

@Directive({ selector: '[svgParentDrag]' })
export class SvgParentDragDirective {
  private x = 0;
  private y = 0;
  private item: SvgDraggable | null = null;

  @Input() svgParentDragScale = 1;
  @Output() readonly svgParentDragEnded = new EventEmitter<SvgDragEndedEvent>();

  constructor(private dragService: SvgDragService) {}

  @HostListener('pointerdown', ['$event'])
  onMouseDown(event: PointerEvent) {
    event.preventDefault();
    this.x = event.clientX;
    this.y = event.clientY;
    if (this.item) {
      this.item.setTranslate(0, 0);
    }
    this.item = this.dragService.find(event.clientX, event.clientY);
  }

  @HostListener('pointermove', ['$event'])
  onMouseMove(event: PointerEvent) {
    event.preventDefault();
    if (this.item) {
      this.item.setTranslate((event.clientX - this.x) / this.svgParentDragScale, (event.clientY - this.y) / this.svgParentDragScale);
    }
  }

  @HostListener('pointerup', ['$event'])
  onMouseUp(event: PointerEvent) {
    event.preventDefault();
    if (this.item) {
      const targetIndex = this.dragService.findTargetIndex(this.item);
      this.item.setTranslate(0, 0);
      if (targetIndex !== null) {
        this.svgParentDragEnded.emit({ index: this.item.getIndex(), targetIndex: targetIndex });
      }
      this.item = null;
    }
  }

  @HostListener('pointerleave', ['$event'])
  onMouseLeave(event: PointerEvent) {
    event.preventDefault();
    if (this.item) {
      this.item.setTranslate(0, 0);
      this.item = null;
    }
  }
}
